<script>
    import TabInfo from './tabInfo.svelte'
    import TabMonsters from './tabMonsters.svelte'
    import TabAddInfo from './tabAddInfo.svelte'

    import ModalInfoIssue from './modal/modalInfoIssue.svelte'
    import ModalDataIssue from './modal/modalDataIssue.svelte'

	import { onMount } from 'svelte'
	import { navigate  } from 'svelte-routing'
    import { WriteData, WriteMonster } from '../../script/handle/write'
    import { CheckContentsData, WriteContents, EditContents  } from '../../script/handle/write'

    export let Num, Check
    let active = 1, OnWait = false

	onMount(async () => {
        if(Num > 0 && !Check && writeData.title == '') {
            alert('에러!')
            navigate("/detail/"+Num)
        }
    })

    let writeData, writeMonster
    WriteData.subscribe(value => { writeData = value})
    WriteMonster.subscribe(value => { writeMonster = value})

    function onList() {
        navigate("/list");
    }

    let ShowInfoIssueModal = false, ShowDataIssueModal = false
    let checkData

    async function onWrite() {
        OnWait = true
        checkData = await CheckContentsData()

        if(checkData.info != '') {
            ShowInfoIssueModal = true
        } else if(checkData.monster != '' || checkData.addInfo != '') {
            ShowDataIssueModal = true
        } else {
            await WriteContents(false)
        }
    }

    async function onEdit() {
        OnWait = true
        checkData = await CheckContentsData()

        if(checkData.info != '') {
            ShowInfoIssueModal = true
        } else if(checkData.monster != '' || checkData.addInfo != '') {
            ShowDataIssueModal = true
        } else {
            await EditContents(Num, false)
        }
    }
</script>

<div class="write">
    <div class="title">
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="56" viewBox="0 0 150 56" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M76.7271 15.3062L76.7795 15.3559H15.356L15.356 55.1094L7.62939e-05 38.9453V15.3559H0V0H60.6154L72.1943 11H145.294L150 15.3062H76.7271Z" fill="#7A67FF"/>
        </svg>

        공략 작성
    </div>

    <div class="btn">
        <button on:click={onList}>
              <svg xmlns="http://www.w3.org/2000/svg" class='writeBtn' width="51" height="50" viewBox="0 0 51 50" fill="none">
                <mask id="path-1-inside-1_389_3545" fill="white">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.97492 48.3855V14.3851L2.82704e-05 12.3063V4.85226H-4.88758e-06V0H19.1537L21.2325 1.97492H48.3855V35.0098L50.9352 37.6937V45.1477H50.9353V50H31.7816L30.0821 48.3855H1.97492Z"/>
                </mask>
                <path d="M1.97492 14.3851H2.97492V13.9858L2.69992 13.6963L1.97492 14.3851ZM1.97492 48.3855H0.974918V49.3855H1.97492V48.3855ZM2.82704e-05 12.3063H-0.999972V12.7055L-0.724971 12.995L2.82704e-05 12.3063ZM2.82704e-05 4.85226H1.00003V3.85226H2.82704e-05V4.85226ZM-4.88758e-06 4.85226H-1V5.85226H-4.88758e-06V4.85226ZM-4.88758e-06 0V-1H-1V0H-4.88758e-06ZM19.1537 0L19.8424 -0.724999L19.5529 -1H19.1537V0ZM21.2325 1.97492L20.5438 2.69992L20.8332 2.97492H21.2325V1.97492ZM48.3855 1.97492H49.3855V0.974918H48.3855V1.97492ZM48.3855 35.0098H47.3855V35.4091L47.6605 35.6985L48.3855 35.0098ZM50.9352 37.6937H51.9352V37.2945L51.6602 37.005L50.9352 37.6937ZM50.9352 45.1477H49.9352V46.1477H50.9352V45.1477ZM50.9353 45.1477H51.9353V44.1477H50.9353V45.1477ZM50.9353 50V51H51.9353V50H50.9353ZM31.7816 50L31.0929 50.725L31.3823 51H31.7816V50ZM30.0821 48.3855L30.7709 47.6605L30.4814 47.3855H30.0821V48.3855ZM0.974918 14.3851V48.3855H2.97492V14.3851H0.974918ZM-0.724971 12.995L1.24992 15.0738L2.69992 13.6963L0.725028 11.6175L-0.724971 12.995ZM-0.999972 4.85226V12.3063H1.00003V4.85226H-0.999972ZM-4.88758e-06 5.85226H2.82704e-05V3.85226H-4.88758e-06V5.85226ZM-1 0V4.85226H0.999995V0H-1ZM19.1537 -1H-4.88758e-06V1H19.1537V-1ZM21.9213 1.24992L19.8424 -0.724999L18.4649 0.724999L20.5438 2.69992L21.9213 1.24992ZM48.3855 0.974918H21.2325V2.97492H48.3855V0.974918ZM49.3855 35.0098V1.97492H47.3855V35.0098H49.3855ZM51.6602 37.005L49.1105 34.321L47.6605 35.6985L50.2102 38.3825L51.6602 37.005ZM51.9352 45.1477V37.6937H49.9352V45.1477H51.9352ZM50.9353 44.1477H50.9352V46.1477H50.9353V44.1477ZM51.9353 50V45.1477H49.9353V50H51.9353ZM31.7816 51H50.9353V49H31.7816V51ZM29.3934 49.1105L31.0929 50.725L32.4704 49.275L30.7709 47.6605L29.3934 49.1105ZM1.97492 49.3855H30.0821V47.3855H1.97492V49.3855Z" fill="#F5124D" mask="url(#path-1-inside-1_389_3545)"/>
                <g opacity="0.5">
                  <rect x="1.97491" y="1.97485" width="46.4106" height="46.4106" fill="#F5124D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2613 4.85226L19.1537 0H-4.88758e-06V4.85226H2.82704e-05V12.3063L4.85229 17.4139L4.85229 4.85226H24.2613Z" fill="#F5124D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.674 45.1477L31.7816 50H50.9353V45.1477H50.9353V37.6937L46.083 32.5861L46.083 45.1477H26.674Z" fill="#F5124D"/>
                </g>
                <rect x="12" y="13.9749" width="25.6489" height="23.6739" rx="2" stroke="white" stroke-width="2"/>
                <rect x="16.9247" y="11" width="15.7993" height="2.96238" rx="1" fill="white"/>
                <circle cx="16.9248" cy="19.8871" r="0.987459" fill="white"/>
                <circle cx="16.9248" cy="25.8119" r="0.987459" fill="white"/>
                <circle cx="16.9248" cy="31.7367" r="0.987459" fill="white"/>
                <path d="M31.7379 30.7493H20.8734C20.3287 30.7493 19.8871 31.193 19.8871 31.7404C19.8871 32.2878 20.3287 32.7315 20.8734 32.7315H31.7379C32.2826 32.7315 32.7241 32.2878 32.7241 31.7404C32.7241 31.193 32.2826 30.7493 31.7379 30.7493Z" fill="white"/>
                <path d="M31.7379 24.8245H20.8734C20.3287 24.8245 19.8871 25.2682 19.8871 25.8156C19.8871 26.363 20.3287 26.8067 20.8734 26.8067H31.7379C32.2826 26.8067 32.7241 26.363 32.7241 25.8156C32.7241 25.2682 32.2826 24.8245 31.7379 24.8245Z" fill="white"/>
                <path d="M31.7379 18.8997H20.8734C20.3287 18.8997 19.8871 19.3434 19.8871 19.8908C19.8871 20.4382 20.3287 20.8819 20.8734 20.8819H31.7379C32.2826 20.8819 32.7241 20.4382 32.7241 19.8908C32.7241 19.3434 32.2826 18.8997 31.7379 18.8997Z" fill="white"/>
              </svg>
        </button>

    </div>

    <div class="menu">
        <div
            class="tab left" on:click={() => active=1}
            class:active={active==1} 
        >
            <div class="txt">공략정보</div>
            <div class="bottomright"></div>
        </div>
        <div
            class="tab middle" on:click={() => active=2}
            class:active={active==2} 
        >
            <div class="topright"></div>
            <div class="txt">몬스터</div>
            <div class="bottomright"></div>
        </div>
        <div
            class="tab right" on:click={() => active=3}
            class:active={active==3} 
        >
            <div class="topright"></div>
            <div class="txt">추가정보</div>
            <div class="bottomright"></div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="79" height="16" viewBox="0 0 79 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M52.0615 0.000488281L35.7096 15.5821H52.0615L68.4135 0.000488281H52.0615Z" fill="#7A67FF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.8444 0.000488281L9.49243 15.5821H25.8444L42.1963 0.000488281H25.8444Z" fill="#7A67FF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M78.2786 0.000488281L61.9266 15.5821H78.2786V0.000488281Z" fill="#7A67FF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0252552 15.5815L16.3772 -7.34329e-05H0.0252552V15.5815Z" fill="#7A67FF"/>
          </svg>
    </div>

    <div class="inputPage">
        {#if active == 1}
            <TabInfo
                bind:Title={writeData.title} bind:Nickname={writeData.nickname}
                bind:Pass={writeData.pass} bind:Memo={writeData.memo}
                bind:Test={writeData.test} bind:Build={writeData.build}
            />
        {:else if active == 2}
            <TabMonsters
                bind:Monsters={writeMonster}
            />
        {:else if active == 3}
            <TabAddInfo
                bind:Formation={writeData.formation}
                bind:Brilliance={writeData.brilliance}
            />
        {/if}
    </div>

    <div class="writeBtn">
        {#if Num > 0}
            <button class='write' on:click={onEdit} disabled={OnWait}>
                수정완료
            </button>
        {:else}
            <button class='write' on:click={onWrite} disabled={OnWait}>
                작성완료
            </button>
        {/if}
    </div>
</div>

{#if ShowInfoIssueModal}
    <ModalInfoIssue
        bind:OnWait
        bind:ShowInfoIssueModal
        bind:CheckInfo={checkData.info}
    />
{/if}

{#if ShowDataIssueModal}
    <ModalDataIssue
        bind:OnWait
        bind:ShowDataIssueModal
        bind:Num
        bind:CheckMonster={checkData.monster}
        bind:CheckAddInfo={checkData.addInfo}
    />
{/if}

<style lang="scss">

    .write {
        width: 100%;
        height: 100%;
        margin-bottom: 20px;

        .title {
            padding-top: 25px;
            padding-left: 30px;

            font-size: 24px;
            font-family: aggro;
            margin-bottom: 20px;
            position: relative;

            svg {
                position: absolute;
                top: 0;
                left: 0;
            }
        }

        .btn {
            width: calc(100% - 16px);
            height: fit-content;
            margin: 10px 0px;
            padding-right: 16px;
            text-align: right;

            button {
                all: unset;
                cursor: pointer;

                .writeBtn {
                    &:hover {
                        g { opacity: 1; }
                    }
                }

                &:disabled {
                    cursor: not-allowed;

                    .writeBtn {
                        g { rect { fill: $cl5; } }
                    }
                }
            }
        }

        .menu {
            position: relative;
            
            .tab {
                width: fit-content;
                height: fit-content;
                vertical-align: top;
                .txt {
                    background: $cl5;
                    padding: 10px 20px 9px 20px;
                    font-size: 20px;
                    font-family: aggro;
                    /*box-shadow : 0px -4px 12px -1px $cl3;*/
                    display: inline-block;
                    vertical-align: top;

                }
                .topright {
                    width: 0;
                    height: 0;
                    border-top: 43px solid $cl5;
                    border-left: 43px solid transparent;
                    display: inline-block;
                    vertical-align: top;
                }
                .bottomright {
                    width: 0;
                    height: 0;
                    border-bottom: 43px solid $cl5;
                    border-right: 43px solid transparent;
                    display: inline-block;
                    vertical-align: top;
                }

                &.active {
                    .txt { background: $cl3; }
                    .topright { border-top: 43px solid $cl3; }
                    .bottomright { border-bottom: 43px solid $cl3; }
                }
                &:hover:not(.active) {
                    cursor: pointer;
                    .txt { background: $cl3; }
                    .topright { border-top: 43px solid $cl3; }
                    .bottomright { border-bottom: 43px solid $cl3; }
                }

                &.middle {
                    position: absolute;
                    top: 0px;
                    left: 116px;
                }
                &.right {
                    position: absolute;
                    top: 0px;
                    left: calc(116px + 43px + 97px);
                }
            }

            svg {
                position: absolute;
                right: 0;
                bottom: 6.42px;
            }    
        }

        .inputPage {
            width: calc(100% - 40px - 6px);
            height: fit-content;
            padding: 20px;
            border: 3px solid $cl3;
        }

        .writeBtn {
            width: 100%;
            height: fit-content;
            text-align: center;

            .write {
                all:unset;
                width: fit-content;
                height: fit-content;
                margin: 50px 0;
                padding: 13px 33px 10px 33px;
                border: 2px solid $cl3;
                font-size: 20px;
                font-family: aggro;
                cursor: pointer;

                &:hover { background: $cl3; }
            }
        }
    }
</style>